import axios from "axios";

export const DEFAULT_MIN_BOOKING_LEAD_HOURS = 4;

let minBookingLeadHours = DEFAULT_MIN_BOOKING_LEAD_HOURS;
let loadPromise = null;

export function setMinBookingLeadHours(hours) {
  const n = Number(hours);
  if (!Number.isFinite(n) || n < 0) {
    return minBookingLeadHours;
  }
  minBookingLeadHours = n;
  return minBookingLeadHours;
}

export function getMinBookingLeadHours() {
  return minBookingLeadHours;
}

export function getMinBookingLeadMs() {
  return getMinBookingLeadHours() * 60 * 60 * 1000;
}

export function formatBookingLeadHoursLabel(hours = getMinBookingLeadHours()) {
  const n = Number(hours);
  if (!Number.isFinite(n) || n <= 0) {
    return null;
  }
  return n === 1 ? "1 hour" : `${n} hours`;
}

export function getPickupMinLeadErrorMessage() {
  const label = formatBookingLeadHoursLabel();
  if (!label) {
    return "Please select a valid future time.";
  }
  return `Please select a valid future time (at least ${label} from now).`;
}

export function getPickupMinLeadError(scheduleStr) {
  if (!scheduleStr) return null;
  const chosen = new Date(scheduleStr);
  if (Number.isNaN(chosen.getTime())) return null;
  const minAllowed = new Date(Date.now() + getMinBookingLeadMs());
  minAllowed.setSeconds(0, 0);
  chosen.setSeconds(0, 0);
  if (chosen < minAllowed) {
    return getPickupMinLeadErrorMessage();
  }
  return null;
}

export function applyBookingAvailabilityPayload(data) {
  if (data && data.min_booking_lead_hours != null) {
    setMinBookingLeadHours(data.min_booking_lead_hours);
  }
  return data;
}

export function loadMinBookingLeadHours() {
  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = axios
    .get(
      `${process.env.REACT_APP_APP_DOMAIN}/api/customer/booking-availability`,
    )
    .then((response) => {
      applyBookingAvailabilityPayload(response?.data);
      return getMinBookingLeadHours();
    })
    .catch(() => getMinBookingLeadHours());

  return loadPromise;
}
